<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">Crusaders and Revolutionaries of the Thirteenth Century: De Montfort</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half.vue?51c91464